import { createFileRoute, redirect } from '@tanstack/react-router'

/** Bare `/w/$workspaceId` → the role-shaped overview (A7). */
export const Route = createFileRoute('/_ws/w/$workspaceId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/w/$workspaceId/overview',
      params: { workspaceId: params.workspaceId },
    })
  },
})
